export const organizer = {
  ROLE: {
    ADMIN: 'admin',
    EDITOR: 'editor',
  },
}
